"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypeList = exports.getBrandList = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 品牌列表
exports.getBrandList = (params) => http().post('/brand/getList', params);
// 分类列表
exports.getTypeList = (params) => http().post('/items/typeList', params);
